import { FormatterHelper } from "../helpers/numbers-helper";
var NumberFormatValueConverter = /** @class */ (function () {
    function NumberFormatValueConverter() {
    }
    NumberFormatValueConverter.prototype.toView = function (value, format, fallback) {
        if (value == 0)
            return 0;
        if (value) {
            return FormatterHelper.getformattedValue(Number(value), navigator.language, format != null && format != undefined ? format : 2);
        }
        else {
            return fallback ? fallback : "";
        }
    };
    return NumberFormatValueConverter;
}());
export { NumberFormatValueConverter };
